
import { callServer } from 'next/dist/client/app-call-server'

function __build_action__(action, args) {
  return callServer(action.$$id, args)
}

/* __next_internal_action_entry_do_not_use__ {"2a306dc35902efc6e9f6d69a631d7ded230ab531":"$$ACTION_0","41795247997468cd897bcf7899caf5c3ca3c8ec8":"GetContactsByClient","6e744593f87d15c0d42ec2f17a98d195a7d29739":"$$ACTION_1","7d598b22ae0a98423b2726cc4758f6e6f88cd62b":"GetContacts","9151a1f922f686d04aca791f94c5ae57018a88c3":"GetContactsTotalCount","a033554b49288f0c7045e9b76588b51d8ce7c6b0":"CreateContact","c7b1562ea3d3ef283d4c40dd7d17b52872cbbef9":"$$ACTION_2","cf3138eaa538fb0f832799e9aa9c900ddcc53c84":"$$ACTION_3"} */ export var CreateContact = createServerReference("a033554b49288f0c7045e9b76588b51d8ce7c6b0");
import { createServerReference } from "private-next-rsc-action-client-wrapper";
export var GetContactsByClient = createServerReference("41795247997468cd897bcf7899caf5c3ca3c8ec8");
export var GetContacts = createServerReference("7d598b22ae0a98423b2726cc4758f6e6f88cd62b");
export var GetContactsTotalCount = createServerReference("9151a1f922f686d04aca791f94c5ae57018a88c3");

